import axios from 'axios';

// Cria uma instância do axios para a API
const api = axios.create({
    baseURL: "https://alleanza-backend.fly.dev/api"//'http://localhost:8000/api', // Substitua pelo URL do seu backend
});

// Função para buscar hospitais próximos com base no CEP
export const fetchHospitalsNearby = async (cep) => {
    try {
        const response = await api.post('/hospitals/nearby', { cep });
        return response.data; // Retorna os hospitais encontrados
    } catch (error) {
        console.error('Erro ao buscar hospitais:', error);
        throw error; // Lança o erro para ser tratado no componente
    }
};

// Função para criar um lead
export const createLead = async (leadData) => {
    try {
        const response = await api.post('/add/leads', leadData);
        return response.data; // Retorna o lead criado
    } catch (error) {
        console.error('Erro ao criar lead:', error);
        throw error;
    }
};

// Função para criar uma solicitação
export const createSolicitation = async (solicitationData) => {
    try {
        const response = await api.post('/add/solicitation', solicitationData);
        return response.data; // Retorna a solicitação criada
    } catch (error) {
        console.error('Erro ao criar solicitação:', error);
        throw error;
    }
};

export const fetchPlansNearby = async (cep) => {
    try {
        const response = await api.post('/plans/nearby', { cep });
        return response.data;  // Retorna a lista de planos
    } catch (error) {
        console.error('Erro ao buscar planos próximos:', error);
        throw error;
    }
};
